export const LOADING_EXCEL_MASSIVE_UPLOAD = "LOADING_EXCEL_MASSIVE_UPLOAD";
export const EXCEL_MASSIVE_UPLOAD_FAIL = "EXCEL_MASSIVE_UPLOAD_FAIL";
export const EXCEL_MASSIVE_UPLOAD_PROBLEMS = "EXCEL_MASSIVE_UPLOAD_PROBLEMS";
